/**
 * Tab Key Constants
 * These constants represent the normalized tab keys used throughout the application
 * They map to the actual Sitecore TabKey values but provide a consistent interface
 */

// Normalized tab keys used in the application for conditions and data management
export const TAB_KEYS = {
  REFERRALS: 'referrals',
  NON_REFERRALS: 'nonReferrals',
  PROCESSED_REFERRALS: 'processedReferrals',
} as const;

// Sitecore TabKey values mapping to normalized keys
export const SITECORE_TAB_KEY_MAP: Record<string, string> = {
  AvacareLMAReferral: TAB_KEYS.REFERRALS,
  AvacareLMANonReferral: TAB_KEYS.NON_REFERRALS,
  AvacareLMAProcessedToCC: TAB_KEYS.PROCESSED_REFERRALS,
};

// Helper function to normalize Sitecore tab keys
export const normalizeTabKey = (sitecoreTabKey: string): string => {
  return SITECORE_TAB_KEY_MAP[sitecoreTabKey] || sitecoreTabKey.toLowerCase();
};

// Type for tab key values
export type TabKey = (typeof TAB_KEYS)[keyof typeof TAB_KEYS];

/**
 * Status Constants
 * These constants represent the possible status values for referral records
 */
export const STATUS = {
  MANUAL_REVIEW_REQUIRED: 'Manual-Review-Required',
  AUTO_MERGE: 'Auto-Merge',
  NEW_RECORD: 'New-Record',
  RETURNING_USER: 'Returning-User',
} as const;

export type Status = (typeof STATUS)[keyof typeof STATUS];

export const LEAD_STATUS = {
  PROCESSED: 'Processed',
  REQUESTED: 'Requested',
} as const;

export type LeadStatus = (typeof LEAD_STATUS)[keyof typeof LEAD_STATUS];

export const RESOURCE_TYPES = [
  { key: 'conditions', label: 'Conditions' },
  { key: 'procedures', label: 'Procedures' },
  { key: 'medications', label: 'Medications' },
  { key: 'immunizations', label: 'Immunizations' },
  { key: 'allergies', label: 'Allergies' },
  { key: 'familyMemberHistory', label: 'Family Member History' },
  { key: 'devices', label: 'Devices' },
] as const;

export type ResourceType = (typeof RESOURCE_TYPES)[number];
